module.exports = __webpack_public_path__ + "img/tu-logo.0a859b42.svg";